type Listener = (orgId: string) => void;

const listeners = new Set<Listener>();

export function emitProjectSelected(orgId: string): void {
  listeners.forEach(l => l(orgId));
}

export function onProjectSelected(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
